import React, { ReactNode } from 'react';

import { VersionInfoUI } from '@portal/components/common/VersionInfo.ui';
import { VERSION_CONFIG } from '@portal/constant/version';

export const Layout = ({
  navbar,
  sidebar,
  children,
  footer,
}: {
  navbar?: ReactNode;
  sidebar?: ReactNode;
  children: () => ReactNode;
  footer?: ReactNode;
}) => {
  if (!sidebar) {
    return (
      <>
        {navbar}
        <main className='container max-w-full mx-auto'>
          <div className='grid grid-cols-12'>
            <div className={`col-span-12 p-8 pb-0 ${navbar && 'mt-[40px]'}`}>{children()}</div>
          </div>
        </main>
        {footer}
        {VERSION_CONFIG.showVersionInfo && <VersionInfoUI version={VERSION_CONFIG.version} />}
      </>
    );
  }

  return (
    <>
      {navbar}
      <main className='container max-w-full mx-auto'>
        <div className='grid grid-cols-12'>
          <div className='col-span-2'>
            <div className='sticky top-4'>{sidebar}</div>
          </div>
          <div className='col-span-10 mt-[40px] p-16'>{children()}</div>
        </div>
      </main>
      {footer}
      {VERSION_CONFIG.showVersionInfo && <VersionInfoUI version={VERSION_CONFIG.version} />}
    </>
  );
};
